import { AsyncPipe, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Loading, LoadingIdsEnum, LoadingTypeEnum } from 'src/app/models/loading.model';
import { BreakpointService } from 'src/app/services/breakspoint.service';
import { AppState } from 'src/app/store';
import { selectConfigLoading } from 'src/app/store/states/config/config.selectors';
import { LoadingProgressBarComponent } from './loading-progress-bar/loading-progress-bar.component';
import { LoadingDefaultComponent } from './loading-spinner/loading-spinner.component';

interface LoadingState {
  loading: boolean;
  loadingConfig: Loading;
}

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    AsyncPipe,
    LoadingProgressBarComponent,
    LoadingDefaultComponent,
  ],
})
export class LoadingComponent {
  isHandSet$ = inject(BreakpointService).isHandset$;
  loadingState$: Observable<LoadingState>;
  loadingIdsEnum = LoadingIdsEnum;
  loadingTypeEnum = LoadingTypeEnum;
  store = inject(Store<AppState>);
  constructor() {
    this.loadingState$ = this.store.select(selectConfigLoading);
  }
}
